const imageElements = (state = [], action) => {
  switch (action.type) {
    case 'ADD_TEXT':
      return [
        ...state,
        {
          id: action.id,
          text: action.text,
          style: action.style,
        }
      ]
    case 'DEL_TEXT':
      return state.filter(element => element.id !== action.id)
    case 'GET_ALL_TEXT':
      return state
    default:
      return state
  }
}

export default imageElements;


// WEBPACK FOOTER //
// ./src/reducers/textElement.reducer.js